import {
  FETCH_WALLET_FAIL,
  FETCH_WALLET_RECEIVED,
  FETCH_WALLET_REQUEST,
  FETCH_WALLET_SUCCESS,
  WALLET_ADDRESS_REMOVE,
  DETECT_MARKET_PLACE_REQUEST,
  DETECT_MARKET_PLACE_APPROVED,
  DETECT_MARKET_PLACE_DENIED,
  FETCH_WALLET_CONNECTION_TYPE,
  FETCH_WALLET_PATH,
  FETCH_WALLET_PATH_ERROR,
  FETCH_WALLET_TRANSPORT,
  FETCH_GG_REWARD_PENDING,
  FETCH_GG_REWARD_FAIL,
  FETCH_GG_REWARD_FULFILLED,
  SET_CLAIM_TIMER_FULFILLED,
  SET_CLAIM_TIMER_FAIL,
  SET_CLAIM_TIMER_PENDING,
} from "../actions/wallet.js";

const defaultState = {
  isLoading: false,
  data: {},
  userGGReward: null,
  userGGRewardLoading: false,
  userGGRewardError: null,
  fetchError: "",
  walletAddress: "",
  isMarketingApproved: "",
  isMarketingLoading: false,
  isMarketingError: "",
  walletType: "",
  walletPath: "",
  walletPathError: "",
  transport: "",
  claimTimer: null,
  claimTimerLoading: false,
  claimTimerError: null,
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_WALLET_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchError: "",
      };

    case FETCH_WALLET_SUCCESS:
      return {
        ...state,
        isLoading: true,
        walletAddress: action.walletAddress,
        fetchError: "",
      };

    case FETCH_WALLET_CONNECTION_TYPE:
      return {
        ...state,
        isLoading: false,
        walletType: action.connectionType,
        fetchError: "",
      };

    case FETCH_WALLET_PATH:
      return {
        ...state,
        isLoading: false,
        walletPath: action.path,
        walletPathError: "",
      };

    case FETCH_WALLET_TRANSPORT:
      return {
        ...state,
        isLoading: false,
        transport: action.transport,
        walletPathError: "",
      };

    case FETCH_WALLET_PATH_ERROR:
      return {
        ...state,
        isLoading: false,
        walletPath: "",
        walletPathError: action.error,
      };

    case FETCH_WALLET_RECEIVED:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        fetchError: "",
      };

    case FETCH_WALLET_FAIL:
      return {
        ...state,
        fetchError: action.error,
        isLoading: false,
      };

    case WALLET_ADDRESS_REMOVE:
      return {
        ...state,
        walletAddress: "",
      };

    case DETECT_MARKET_PLACE_REQUEST:
      return {
        ...state,
        isMarketingLoading: true,
        isMarketingError: "",
      };

    case DETECT_MARKET_PLACE_APPROVED:
      return {
        ...state,
        isMarketingApproved: action.approved,
        isMarketingLoading: false,
      };

    case DETECT_MARKET_PLACE_DENIED:
      return {
        ...state,
        isMarketingError: action.error,
        isMarketingLoading: false,
      };
    case FETCH_GG_REWARD_FAIL:
      return {
        ...state,
        userGGReward: null,
        userGGRewardError: action.error,
        userGGRewardLoading: false,
      };
    case FETCH_GG_REWARD_FULFILLED:
      console.log("gg_reward");
      console.log(action);
      return {
        ...state,
        userGGReward: action.data,
        userGGRewardLoading: false,
        userGGRewardError: null,
      };
    case FETCH_GG_REWARD_PENDING:
      return {
        ...state,
        userGGRewardError: null,
        userGGRewardLoading: true,
      };

    case SET_CLAIM_TIMER_FAIL:
      return {
        ...state,
        claimTimer: null,
        claimTimerLoading: false,
        claimTimerError: true,
      };
    case SET_CLAIM_TIMER_FULFILLED:
      return {
        ...state,
        claimTimer: action.data,
        claimTimerLoading: false,
        claimTimerError: null,
      };
    case SET_CLAIM_TIMER_PENDING:
      return {
        ...state,
        claimTimer: null,
        claimTimerLoading: true,
        claimTimerError: null,
      };
    default:
      return state;
  }
};

export default reducer;
